import React from "react";
import { BoxIcon } from "lucide-react";
interface ObjectIconProps {
  icon: BoxIcon;
  bg: string;
  size?: 'xs' | 'sm' | 'lg';
}
const sizes = {
  xs: {
    box: 'h-4 w-4',
    icon: 'h-2.5 w-2.5'
  },
  sm: {
    box: 'h-6 w-6',
    icon: 'h-3.5 w-3.5'
  },
  lg: {
    box: 'h-9 w-9',
    icon: 'h-5 w-5'
  }
};
export function ObjectIcon({
  icon: Icon,
  bg,
  size = 'sm'
}: ObjectIconProps) {
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded ${sizes[size].box}`} style={{
    backgroundColor: bg
  }} data-id="element-867" data-mp="24m5akgucgmi0">
      <Icon className={`${sizes[size].icon} text-white`} strokeWidth={2.25} data-id="element-868" data-mp="1zp55o998dpsh" />
    </span>;
}